import type { SvgComponent } from '@/types/react-components';

export const SelectChevron = ({ ...props }: SvgComponent) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="8"
    viewBox="0 0 10 8"
    fill="none"
    {...props}
  >
    <path
      d="M10 2.11778L8.76448 0.882263L5 4.64674L1.23552 0.882263L0 2.11778L5 7.11778L10 2.11778Z"
      fill="#563F8E"
    />
  </svg>
);
